var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgClear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5001 13.5363L18.6455 19.6818C19.0697 20.1061 19.7576 20.1061 20.1818 19.6818C20.6061 19.2575 20.6061 18.5697 20.1818 18.1454L14.0364 12L20.1818 5.85456C20.6061 5.43031 20.6061 4.74246 20.1818 4.31821C19.7576 3.89395 19.0697 3.89395 18.6455 4.31821L12.5001 10.4637L6.35455 4.31819C5.9303 3.89394 5.24244 3.89394 4.81819 4.31819C4.39394 4.74245 4.39394 5.43029 4.81819 5.85455L10.9636 12L4.81819 18.1455C4.39394 18.5697 4.39394 19.2575 4.81819 19.6818C5.24244 20.1061 5.9303 20.1061 6.35455 19.6818L12.5001 13.5363Z",
    fill: "#7B7E82"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgClear);
export default __webpack_public_path__ + "static/media/imgClear.2a639c3bdd4d69debee0cc6f3a3a530e.svg";
export { ForwardRef as ReactComponent };